/**
 * THIS FILE IS AUTOGENERATED. DO NOT EDIT.
 * To regenerate these files after changing A/B test configs, run this command:
 * `npm run generate-ab-tests`
 */

import {
  __abTest_base,
  __useAbTest_base,
  __inWinnerHoldout_base,
} from 'js/ab_tests/ab_test';

export const TEST_CONFIG = {
  active: true,
  finished: false,
  alternatives: [
    'control',
    'bundle_grid_v6',
    'rotating_preview_v7',
    'source_anchor_v8',
    'first_bullet_personalization_v9',
    'blurred_hidden_thumbs_v10',
    'bucket_badges_v14',
    'trust_signal_v18',
    'guarantee_badge_v19',
    'full_bundle_v20',
    'combined_leaders_v21',
    'evidence_first_m1',
    'progressive_disclosure_m2',
    'split_verdict_m3',
    'category_tabs_m4',
    'paper_browser_m5',
    'social_proof_injection_m6',
  ],
} as const;

/**
 * Synchronously returns the variant for this A/B test:
 * bulk_download_2026_q2_modal_mechanics_v2
 *
 * Returns the bucket based on the current logged-in user id.
 * This function also makes a call to the server to bucket
 * the user server-side, but does not return the response.
 *
 * Once a user is bucketed, their variant for the test
 * is stored in `sessionStorage`, which we check to avoid
 * making duplicate bucketing calls to the server.
 * `sessionStorage` is cleared when the user closes their tab.
 */
export function abTest() {
  return __abTest_base('bulk_download_2026_q2_modal_mechanics_v2', TEST_CONFIG);
}

/**
 * React hook to return the bucket for this A/B test:
 * bulk_download_2026_q2_modal_mechanics_v2
 *
 * Returns the bucket based on the current logged-in user id.
 * Asynchronously records the test on the backend.
 */
export function useAbTest() {
  return __useAbTest_base(
    'bulk_download_2026_q2_modal_mechanics_v2',
    TEST_CONFIG,
  );
}

/**
 * Returns whether the user is in the winner holdout for this A/B test:
 * bulk_download_2026_q2_modal_mechanics_v2
 *
 * Returns true if all of the following are true:
 * - The test is finished
 * - The user is in the overall holdout
 * - The user is in the winner sub-holdout
 */
export function inWinnerHoldout() {
  return __inWinnerHoldout_base(
    'bulk_download_2026_q2_modal_mechanics_v2',
    TEST_CONFIG,
  );
}

// MD5 hash of test's YAML config; modification will fail commit hook
// cc4c9e3ea8589ecbdb5e419e3f96a745
